<template>
  <div class="organizations">
    <!-- <div v-if="canFilter" class="table__filter">
      <InputControl
        id="organizations-filter"
        v-model="filter"
        label="Filtrowanie"
        :inline="true"
        label-class="col-md-2 col-form-label form__label"
        control-class="col-md-4 form__control"
      />
    </div> -->

    <b-table
      v-if="organizations.length"
      :items="organizations"
      :fields="organizationsTableFields"
      aaafilter="filter"
      responsive
      :busy="loading"
      hover
    >
      <template v-slot:cell(check)="data">
        <Icon v-if="data.item.approved" name="check" />
      </template>

      <template v-slot:cell(name)="data">
        {{ data.item.name }}
      </template>

      <template v-slot:cell(address)="data">
        {{ data.item.address }}
      </template>

      <template v-slot:cell(zip_city)="data">
        {{ data.item.zip }} {{ data.item.city }}
      </template>

      <template v-slot:cell(approved)="data">
        <span v-if="!data.item.approved" class="organizations__not-approved">
          Niepotwierdzone przez CO!
        </span>
      </template>

      <template v-slot:cell(actions)="data">
        <Btn
          v-if="canEdit"
          icon="pen"
          size="sm"
          variant="link-white"
          tooltip="Edytuj"
          @click="edit(data.item.id)"
        />
        <Btn
          v-if="data.item.canApprove(user)"
          icon="user-plus"
          size="sm"
          variant="link-white"
          tooltip="Zatwierdź"
          @click="approve(data.item.id)"
        />
        <Btn
          icon="file-alt"
          size="sm"
          variant="link-white"
          tooltip="Pokaż"
          @click="view(data.item.id)"
        />
        <Btn
          v-if="canRemove"
          variant="link-white"
          size="sm"
          tooltip="Usuń"
          icon="trash"
          @click="remove(data.item.id)"
        >
        </Btn>
      </template>
    </b-table>

    <b-modal
      id="view-organization"
      ref="view-organization"
      hide-footer
      title="Organizacja"
    >
      <OrganizationFormModal
        id="organization-edit"
        v-model="selectedOrganization"
        :can-select="false"
        :save-loaded="false"
        :never-save="true"
        :disabled="true"
        save-btn-text="Zamknij"
        save-btn-icon="times"
        @form:selected="closeViewOrganization"
      />
    </b-modal>
  </div>
</template>
<script>
import OrganizationList from "@/components/Organization/OrganizationList";
import OrganizationFormModal from "@/components/Organization/OrganizationFormModal";

import ModalConfirm from "@/mixins/ModalConfirm";
import ModelFactory from "@/model/ModelFactory";
import { mapState, mapGetters } from "vuex";

export default {
  name: "UserOrganizationList",
  components: {
    OrganizationFormModal
  },
  extends: OrganizationList,
  mixins: [ModalConfirm],
  props: {
    canEdit: {
      type: Boolean,
      default: true
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    canFilter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedOrganization: ModelFactory.create("OrganizationModel"),
      organizationsTableFields: [
        {
          key: "check",
          label: "",
          tdClass: "organizations__td-approved"
        },
        { key: "name", label: "Nazwa" },
        { key: "address", label: "Adres" },
        { key: "zip_city", label: "Miejscowość" },
        { key: "approved", label: "" },
        { key: "actions", label: "", class: "table__actions" }
      ]
    };
  },
  computed: {
    ...mapState("Account", ["account", "loading"]),
    ...mapGetters("Account", { organizations: "getUserOrganizations" }),
    ...mapGetters("Account", ["getOrganizationById"]),
    ...mapState("User", ["user"])
  },
  methods: {
    view(organizationId) {
      this.selectedOrganization = this.getOrganizationById(organizationId);
      this.$bvModal.show("view-organization");
    },

    closeViewOrganization() {
      this.$bvModal.hide("view-organization");
    },

    approve(organizationId) {
      this.$store.dispatch("Account/approveOrganization", {
        organizationId,
        userId: this.account.id
      });
    },

    remove(organizationId) {
      let organizationName = this.getOrganizationById(organizationId).name;
      let h = this.$createElement;
      let msg = [
        h("p", "Czy na pewno usunąć organizację"),
        h("p", [h("strong", `${organizationName}?`)]),
        h(
          "p",
          "Ponowne dołączenie do organizacji wymaga zatwierdzenia przez Compliance Officera."
        )
      ];

      this.deleteDialog(msg).then(confirm => {
        if (confirm) {
          this.$store.dispatch("Account/leaveOrganization", {
            organizationId,
            userId: this.account.id
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.organizations__td-approved {
  width: 20px;
}

.organizations__not-approved {
  color: $col-polmed-red;
}
</style>
